export default "__VITE_ASSET__k9kZnuVd__"